// Incubations Controller
// Handles incubation-related operations

import { post } from './utilitiesController.js';

/**
 * Create a new incubation
 * @param {Object} data - Data for the new incubation
 * @returns {Promise} - Response from incubation creation endpoint
 */
export const createIncubation = async (data) => {
    try {
        const response = await post('api/inc/create_incubation', data, true);
        return response;
    } catch (error) {
        console.error('Failed to create incubation:', error);
        throw error;
    }
};

/**
 * Get list of all incubations
 * @param {Object} params - Query parameters for pagination/filtering
 * @returns {Promise} - Response from incubations list endpoint
 */
export const getIncubations = async (params = {}) => {
    try {
        const response = await post('api/inc/list', params, true);
        return response;
    } catch (error) {
        console.error('Failed to get incubations:', error);
        throw error;
    }
};

/**
 * Get specific incubation details
 * @param {string} incubationId - ID of the incubation to fetch
 * @returns {Promise} - Response from incubation details endpoint
 */
export const getIncubation = async (data) => {
    try {
        const response = await post('api/inc/get_incubation', data, true);
        return response;
    } catch (error) {
        console.error('Failed to get incubation:', error);
        throw error;
    }
};

/**
 * Delete an incubation
 * @param {string} incubationId - ID of the incubation to delete
 * @returns {Promise} - Response from incubation deletion endpoint
 */
export const deleteIncubation = async (data) => {
    try {
        const response = await post('api/inc/delete', data, true);
        return response;
    } catch (error) {
        console.error('Failed to delete incubation:', error);
        throw error;
    }
};

/**
 * Update an existing incubation
 * @param {Object} data - Data containing incubation_id and fields to update
 * @returns {Promise} - Response from incubation update endpoint
 */
export const updateIncubation = async (data) => {
    try {
        const response = await post('api/inc/update', data, true);
        return response;
    } catch (error) {
        console.error('Failed to update incubation:', error);
        throw error;
    }
};

/**
 * Update field positions for an incubation
 * @param {Object} data - Data containing incubation_id and field arrays
 * @returns {Promise} - Response from field positions update endpoint
 */
export const updateFieldPositions = async (data) => {
    try {
        const response = await post('api/inc/update_field_positions', data, true);
        return response;
    } catch (error) {
        console.error('Failed to update field positions:', error);
        throw error;
    }
};

/**
 * Get incubation logs
 * @param {Object} data - Data containing incubation_id and optional pagination parameters
 * @returns {Promise} - Response from incubation logs endpoint
 */
export const getIncubationLogs = async (data) => {
    try {
        const response = await post('api/inc/get_incubation_logs', data, true);
        return response;
    } catch (error) {
        console.error('Failed to get incubation logs:', error);
        throw error;
    }
};

export const getWebhookJoin = async (data) => {
    try {
        const response = await post('api/inc/get_webhook_join', data, true);
        return response;
    } catch (error) {
        console.error('Failed to get webhook join details:', error);
        throw error;
    }
};

export default {
    createIncubation,
    getIncubations,
    getIncubation,
    deleteIncubation,
    updateIncubation,
    updateFieldPositions,
    getIncubationLogs,
    getWebhookJoin
};
